<template>
    <div>
        <pageHeader  @search="searchCoursesWithKeyword" :showIndex="1"></pageHeader>
        <crumbs :crumbs="crumbsText"></crumbs>
        <div id="course">
            <div class="course-wrap clearfix">
                <div class="cour-content fl">
                    <div class="filter-wrapper clearfix">
                        <div>
                            <!-- @change="refreshData" -->
                            <course-filter @change="refreshData" ref="courseFilter"></course-filter>
                        </div>
                        <div class="fl dataTime">
                        </div>
                    </div>
                    <div class="course-list"  v-loading.body="loading" element-loading-text="数据加载中">
                        <div class="w-sort-bar">
                            <ul class="clearfix">
                                <li><a :class="{cur:tabbar[0].isSeleted}" href="javascript:void(0);" @click="conditionTwoClick(0)">综合排序</a></li>
                                <li><a :class="{cur:tabbar[1].isSeleted}" href="javascript:void(0);" @click="conditionTwoClick(1)">人气</a></li>
                                <li><a :class="{cur:tabbar[2].isSeleted}" href="javascript:void(0);" @click="conditionTwoClick(2)">最新</a></li>
                                <li class="price">
                                <a :class="{cur:tabbar[3].isSeleted}" href="javascript:void(0);" @click="conditionTwoClick(3)">
                                    价格
                                </a>
                                <span class="price-arrow" @click="conditionTwoClick(3)">
                                    <i class="iconfont caret-top" :class="{active:tabbar[3].isTop}">&#xe601;</i>
                                    <i class="iconfont caret-bottom" :class="{active:tabbar[3].isBottom}">&#xe63e;</i>
                                </span>
                                </li>
                                <li><a :class="{cur:tabbar[4].isSeleted}" href="javascript:void(0);" @click="conditionTwoClick(4)">免费课</a></li>
                            </ul>
                        </div>
                        <div>
                          <div>
                            <course-item v-loading.body="loading" :courseItem="courseList" ></course-item>
                          </div>
                          <div  v-if="courseList.length == 0" class="empty">
                            <img src="../../assets/images/empty.png">
                          </div>
                          <div class="page-wrap">
                            <el-pagination
                              @current-change="handleCurrentChange"
                              :current-page="currentPage"
                              :page-size="8"
                              layout="prev, pager, next,total"
                              :total="total">
                            </el-pagination>
                          </div>
                        </div>    
                    </div>

                </div>
            </div>
        </div>
        <pageFooter></pageFooter>
    </div>
</template>
<script>
import pageHeader from '../header/header'
import pageFooter from "../footer/pageFooter"
import Crumbs from '../crumbs/crumbs'
import CourseFilter from './courseFilter.vue'
import CourseItem from './courseItem'
export default {
    components: {
        pageHeader,
        pageFooter,
        Crumbs,
        CourseFilter,
        CourseItem
    },
    data() {
        return {
            loading:true,
            sortType:'',      //排序
            tabbar:[
                {isSeleted:true},
                {isSeleted:false},
                {isSeleted:false},
                {isSeleted:false,isTop:false,isBottom:false},
                {isSeleted:false}
            ],
            courseList:[],  //课程列表
            crumbsText:[
                {name:'课程'}
            ],
            currentPage: 1,  //当前页
            total:0,         //课程总数量
            postParams:{}   //请求参数
        }
    },
    created(){
      this.currentPage1 = 1

      this.searchType = this.$route.params.searchType
      // console.log(this.searchType,"shouc--")
      if(this.searchType == 1001){
        this.courseName = this.$route.params.keyWord
      }
      
      if(this.searchType == 1002){
        this.juniorId = this.$route.params.juniorId;

        var self = this;
        setTimeout(function() {
          self.toLession()
        }, 500);

      }
      this.loadCourseList();
    },
    methods:{
        toLession(){
          // console.log('ddddddddd')
          this.$refs.courseFilter.filterTo(this.juniorId);

          //this.$refs.courseFilter.test()
        },
        //关键字检索
        searchCoursesWithKeyword(param){
          this.courseName = param.keyWord;

          this.loadCourseList();
        },

        //课程筛选器回调
        refreshData(valueData){
            this.subjectId = valueData.subject  //科目
            this.coursType = valueData.courseType  //课程类型
            this.juniorId = valueData.juniorId  // 年段

            this.loadCourseList();
        },

        //加载课程列表信息
        loadCourseList(){
            this.postParams.juniorId = this.juniorId //小学
            this.postParams.subjectId = this.subjectId  //科目
            this.postParams.courseType = this.coursType
            this.postParams.sortType = this.sortType
            this.postParams.courseName = this.courseName
            this.postParams.page = this.currentPage
            this.postParams.pageSize = 8;
            this.$http.post(this.baseUrl()+'/mobile/tbCourse/findCourseByBuyNum',
                this.$qs.stringify(this.postParams),
                {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then((successResp) => {
                console.log(successResp.data);
                this.courseList = successResp.data.data;
                this.total = successResp.data.totalNum;
                this.loading = false;
            }
            );

        },
        //换页处理
        handleCurrentChange(val) {
          this.currentPage = val;
          this.loadCourseList()
        },
        // conditionOneClick(index,type){},
        conditionTwoClick(type){
          this.realPrice = ''
          if(type == 0){
            this.sortType = '1'
            // this.params.sortType = 1
          }else if(type == 1){
            this.sortType = '6'
            // this.params = {}
          }else if(type == 2){
            this.sortType = '3'
            // this.params.sortType = 3
          }else if(type == 3){
            var model = this.tabbar[type]
            if(model.isTop == false){
                //高-低
                this.sortType = '5'
                // this.params.sortType = 4 
              }else {
                this.sortType = '4'
            }
          }else if(type == 4){
            this.realPrice = '0'
          }
          this.isCur(type)
          this.currentPage1 = 1
          this.loadCourseList()
        },
        isCur(type){
          // console.log('isCur',type)
          // this.tabbar
          for(var i=0;i<this.tabbar.length;i++){
            var model = this.tabbar[i]
            if(i == type){
              // console.log('isCur',type)
              model.isSeleted = true
              if(type == 3){
                if(model.isTop == false){
                  model.isTop = true
                  model.isBottom =false
                }else {
                  model.isTop = false
                  model.isBottom = true
                }
              }
              // console.log('isCur',type)
            }else {
              model.isSeleted = false
              model.isTop = false
              model.isBottom = false
            }
          }
          // console.log(this.tabbar)
        },

    }

}
</script>
<style>
    #course{
        width: 100%;
        background: #f7f7f7;
    }
    .course-wrap{
        width: 1200px;
        margin:0 auto;
        min-height: 600px;
        /*border:1px solid #000;*/
    }
    .dataTime .timeIcon{
        color: #00ced1;
    }
    .left-nav{
  width: 23%;
  /*width: 280px;*/
  min-height: 500px;
  margin-right: 10px;
  background: #fff;
 /* position: fixed;
  top: 100px;*/
  margin-bottom: 40px;
}
.in-grades{
  font-size: 16px;
  background: #00ced1;
  color: #fff;
  padding: 17px 8px 17px 20px;
  position: relative;
}
.in-grades span{
  font-size: 16px;
}
.in-grades i.iconfont{
  cursor: pointer;
}
.in-grades-group{
  position: absolute;
  top: 55px;
  left: 0;
  z-index: 1;
  width: 100%;
  /*height: 100%;*/
  background: #515b6a;
  padding-bottom: 50px;
  /*display: none;*/
}

.in-grades-group .subject li{
  border-bottom: 1px solid #dfdfdf;
  padding: 6px 20px 19px 6px;
}
.in-grades-group .subject li:last-child{
  border-bottom: none;
}
.in-grades-group .subject li .title{
  padding: 7px 15px;
}
.in-grades-group .subject li a{
  display: inline-block;
  padding: 7px 25px;
  color: #fff;
}
.in-grades-group .subject li a:hover{
  color: #0fc9cd;
}
.knowledge-tree{
  min-height: 75vh;
  height: 650px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 20px;
}

.cour-content{
  width: 100%;
  background-color: #f7f7f7;
}
.right-content{
  width:76%;
  /*width: 100%;*/
  background: #f7f7f7;
  /*margin-left: 280px;*/
}
  /* 筛选框 */
.filter-wrapper .el-input__inner{
  height: 30px;
}
.filter-wrapper .dataTimeInput .el-input__inner{
  height: 30px;
  border-radius:0;
  border-color:#dfdfdf; 
  background:none;color:#dfdfdf;
}

.filter-wrapper .filter-one{
  width: 108px;
  margin-right:24px;      
}
.filter-one .el-select:hover{
  border-color:none;
}
.filter-one .el-select:hover .el-input__inner{
  background-color: #fff; 
}
.filter-one .el-select .el-input__inner{
  border:1px solid #dfdfdf;
  border-radius:0;
  background-color:#f7f7f7;
  color:#666;
}
.el-input__inner:hover{
  border-color: #dfdfdf;
}
/* 下拉框icon 颜色 */
.filter-one .el-select .el-input .el-input__icon{
  color: #999;
}
/*设置 placeholder 颜色*/
.filter-one .el-select .el-input__inner::-webkit-input-placeholder { /* WebKit browsers */ 
color: #666; 
} 
.filter-one .el-select .el-input__inner:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
  color: #666; 
} 
.filter-one .el-select .el-input__inner::-moz-placeholder { /* Mozilla Firefox 19+ */ 
  color: #666; 
} 
.filter-one .el-select .el-input__inner:-ms-input-placeholder { /* Internet Explorer 10+ */ 
  color: #666; 
} 

.course-list .w-sort-bar{
  margin: 15px 0 7px 0;
  background: #fff;
}
.course-list .w-sort-bar li{
  float: left;
  padding:10px 20px;
}

.w-sort-bar a{
  display: inline-block;
  color: #666;

}
.w-sort-bar a:hover,
.w-sort-bar a.cur{
  color: #f49d40;
}
.w-sort-bar .price .price-arrow{
  display: inline-block;
  position: relative;
}
.w-sort-bar .price .price-arrow i{
  display: block;
  position: absolute;
  font-size: 12px;
  color: #ccc;
  cursor: pointer;
}
.w-sort-bar .price .price-arrow i:hover,
.w-sort-bar .price .price-arrow i.active{
  color: #f49d40;
}
.w-sort-bar .price .caret-top{
  bottom: 1px;
}
.w-sort-bar .price .caret-bottom{
  top: -5px;
}


/*w-sort-bar*/

.course-list .course-item{
  float: left;
  padding: 10px 10px 0 10px;
}
.course-list .course-item:hover{
  background: #fff;
  box-shadow: 1px 1px 4px 2px #ECECEC;
}
.course-item:hover .item-footer .bottom-line{
  border-color: #fff;
}
/*.course-item .item-content{
  position: relative;
  width: 255px;
  height: 152px;
}*/
.course-item .item-content{
  position: relative;
  width: 280px;
  height: 165px;
  overflow: hidden;
}
.course-item .item-content img{
  width: 100%;
  max-width: 100%;
  /*width: 280px;*/
  /*height: 165px;*/
}
.course-item .item-content:hover .hover-layer{
  display: block;
}
.course-item .item-content .hover-layer{
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
}
.course-item .item-content .join-classroom{
  margin-top: 25%;
}
.item-footer .bottom-line{
  width: 87%;
  margin: 0 19px;
  display: inline-block;
  border-bottom: 1px solid #dfdfdf;
}
</style>